<div class="fd-accreditation-form__container">
  <div class="forms" fxLayout="column" fxLayoutAlign="center stretch">
    <h4 class="fd-subtitle">BUSCA DE MCC POR CNPJ E CNAE</h4>

    <form *ngIf="!!formGroup && !!fields" [formGroup]="formGroup">
      <div fxLayout="row" fxLayoutGap="16px" fxLayout.lt-md="column" fxLayoutAlign="start center">
        <h4 class="fd-subtitle filter-label" fxFlex="none">Informe o CNPJ que deseja consultar:</h4>

        <div fxFlex="24" fxFlex.lt-md="100">
          <fd-input [parentForm]="formGroup" [field]="$any(fields.cnpj)"></fd-input>
        </div>

        <h4 class="fd-subtitle filter-label" fxFlex="none">Informe CNAE:</h4>

        <div fxFlex="16" fxFlex.lt-md="100">
          <fd-input [parentForm]="formGroup" [field]="$any(fields.cnae)"></fd-input>
        </div>

        <div fxFlex="none" fxFlex.lt-md="100">
          <button
            class="custom-button custom-button--inline"
            type="button"
            matTooltip="Buscar"
            [disabled]="formGroup.invalid || isLoading"
            (click)="getMccsByCnpjAndCnae()">
            {{ isLoading ? 'BUSCANDO...' : 'BUSCAR' }}
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="state-container">
    <p class="state-message">Buscando informações...</p>
  </div>

  <!-- Erro -->
  <div *ngIf="hasError && !isLoading" class="state-container state-error">
    <p class="state-message">Ocorreu um erro ao realizar a consulta. Tente novamente.</p>
  </div>

  <!-- Vazio -->
  <div *ngIf="isEmpty && !isLoading" class="state-container">
    <p class="state-message">Nenhum resultado encontrado para o CNPJ e CNAE informados.</p>
  </div>

  <!-- Resultado -->
  <div *ngIf="result && !isLoading">
    <table mat-table [dataSource]="[result]" class="table" style="width: 100%">

      <ng-container matColumnDef="mccAbecs">
        <th mat-header-cell *matHeaderCellDef>MCC indicado pela ABECS</th>
        <td mat-cell *matCellDef="let element">
          {{ formatMccAbecsNumberAndDescription(element.mccAbecs, element.mccAbecsDescription) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="mccCnae">
        <th mat-header-cell *matHeaderCellDef>MCC relacionado ao CNAE</th>
        <td mat-cell *matCellDef="let element">
          {{ formatMccCnaeNumberAndDescription(element.mccCnae, element.mccCnaeDescription) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['mccAbecs', 'mccCnae']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['mccAbecs', 'mccCnae'];"></tr>
    </table>
  </div>
</div>
